import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HeaderService } from './header.service';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { NotificationsService } from 'src/app/services/notifications-services/notifications.service';
import { HeaderConnectionErrorService } from 'src/app/components/header-components/header-connection-error/header-connection-error.service';
import { TranslateService, MissingTranslationHandler } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() sidenavMobile: boolean;
  @Input() sidenavOpened: boolean;
  @Input() navbarHeight: number;
  breadcrumb;

  constructor(private headerService: HeaderService,
              private headerBreadcrumbService: HeaderBreadcrumbService,
              private notificationsService: NotificationsService,
              private headerConnectionErrorService: HeaderConnectionErrorService) { }

  ngOnInit() {
    this.isOffline();
    this.listenBreadcrumbRoutes();
  }

  public listenBreadcrumbRoutes() {
    this.headerBreadcrumbService.listen().subscribe(
      (breadcrumb) => {
        this.breadcrumb = breadcrumb;

      }
    );
  }

  public toggleSearchOverlay() {
    this.headerService.toggle(this);
  }

  public isOffline() {
    this.notificationsService.isOffline().subscribe(
      (res) => {
        this.headerConnectionErrorService.showConnectionError(res);
      }
    );
  }

}
